import React, { useState, useCallback } from 'react';
import moment from 'moment';
import { Badge, Container } from 'react-bootstrap';
import CommonTable from './table/CommonTable';
import DatePicker from './date/DatePicker';

const TurnaroundTime = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isDataFetched, setIsDataFetched] = useState(true);

  const dummyData = [
    {
      centerName: 'AMRIT HEART',
      studies: [
        {
          id: 94,
          studyName: 'VCC',
          contrast: true,
          govtPrice: '933',
          pvtPrice: '1200',
          centerPrice: '800',
          Modality: 'CT',
        },
      ],
      caseDate: '2024-11-01',
      patientName: 'Rajesh Kumar',
      patientID: 'APLO12345',
      panel: 'Government',
      assignments: ['Dr AMIT JHALANI', 'Dr MUKESH JI'],
      caseCompletion: '2024-11-04',
      images: '124',
      completedBy: 'Dr. Priya Verma',
      reportUploadTime: '2024-11-01T08:30:00',
      reportCompletionTime: '2024-11-01T09:15:00',
    },
    {
      centerName: 'Bhuvan Diagnostic Center',
      studies: [
        {
          id: 95,
          studyName: 'X-Ray',
          contrast: false,
          govtPrice: '400',
          pvtPrice: '600',
          centerPrice: '500',
          Modality: 'X-Ray',
        },
      ],
      caseDate: '2024-11-05',
      patientName: 'Sita Verma',
      patientID: 'APLO12346',
      panel: 'Private',
      assignments: ['Dr RAVI SHARMA'],
      caseCompletion: '2024-11-06',
      images: '50',
      completedBy: 'Dr. Ravi Kumar',
      reportUploadTime: '2024-11-05T09:00:00',
      reportCompletionTime: '2024-11-05T10:30:00',
    },
    {
      centerName: 'Boss Diagnostic',
      studies: [
        {
          id: 96,
          studyName: 'MRI Brain',
          contrast: true,
          govtPrice: '1500',
          pvtPrice: '1800',
          centerPrice: '1000',
          Modality: 'MRI',
        },
      ],
      caseDate: '2024-11-07',
      patientName: 'Vijay Singh',
      patientID: 'APLO12347',
      panel: 'Government',
      assignments: ['Dr ANITA KUMAR', 'Dr RAJESH KUMAR'],
      caseCompletion: '2024-11-10',
      images: '16',
      completedBy: 'Dr. Rajesh Singh',
      reportUploadTime: '2024-11-07T11:15:00',
      reportCompletionTime: '2024-11-07T12:30:00',
    },
    {
      centerName: 'Bikaner Imaging',
      studies: [
        {
          id: 97,
          studyName: 'CT Chest',
          contrast: false,
          govtPrice: '1200',
          pvtPrice: '1500',
          centerPrice: '1400',
          Modality: 'CT',
        },
      ],
      caseDate: '2024-11-12',
      patientName: 'Sunita Devi',
      patientID: 'APLO12348',
      panel: 'Private',
      assignments: ['Dr MUKESH JI'],
      caseCompletion: '2024-11-14',
      images: '27',
      completedBy: 'Dr. Mukesh Kumar',
      reportUploadTime: '2024-11-12T08:45:00',
      reportCompletionTime: '2024-11-12T10:00:00',
    },
    {
      centerName: 'BUNDELKHAND MRI & DIAGNOSTIC CENTER',
      studies: [
        {
          id: 98,
          studyName: 'Ultrasound Abdomen',
          contrast: false,
          govtPrice: '700',
          pvtPrice: '900',
          centerPrice: '800',
          Modality: 'Ultrasound',
        },
      ],
      caseDate: '2024-11-15',
      patientName: 'Amit Singh',
      patientID: 'APLO12349',
      panel: 'Private',
      assignments: ['Dr RAJESH KUMAR'],
      caseCompletion: '2024-11-18',
      images: '88',
      completedBy: 'Dr. Anita Verma',
      reportUploadTime: '2024-11-15T07:30:00',
      reportCompletionTime: '2024-11-15T08:45:00',
    },
    {
      centerName: 'Capital Imaging',
      studies: [
        {
          id: 99,
          studyName: 'CT Scan Brain',
          contrast: true,
          govtPrice: '1200',
          pvtPrice: '1500',
          centerPrice: '1000',
          Modality: 'CT',
        },
      ],
      caseDate: '2024-11-19',
      patientName: 'Neha Sharma',
      patientID: 'APLO12350',
      panel: 'Government',
      assignments: ['Dr ANITA KUMAR', 'Dr MUKESH JI', 'DR. Priya'],
      caseCompletion: '2024-11-22',
      images: '12',
      completedBy: 'Dr. Priya Verma',
      reportUploadTime: '2024-11-19T10:15:00',
      reportCompletionTime: '2024-11-19T11:45:00',
    },
    {
      centerName: 'Ganesh Diagnostic Delhi',
      studies: [
        {
          id: 100,
          studyName: 'X-Ray Chest',
          contrast: false,
          govtPrice: '350',
          pvtPrice: '450',
          centerPrice: '300',
          Modality: 'X-Ray',
        },
      ],
      caseDate: '2024-11-20',
      patientName: 'Ravi Yadav',
      patientID: 'APLO12351',
      panel: 'Private',
      assignments: ['Dr RAVI SHARMA'],
      caseCompletion: '2024-11-23',
      images: '30',
      completedBy: 'Dr. Ravi Yadav',
      reportUploadTime: '2024-11-20T09:00:00',
      reportCompletionTime: '2024-11-20T10:15:00',
    },
  ];

  const getFilteredData = useCallback(() => {
    if (!startDate || !endDate) {
      return dummyData;
    }

    return dummyData.filter((row) => {
      const caseDate = moment(row.caseDate);
      return caseDate.isBetween(moment(startDate), moment(endDate), 'day', '[]');
    });
  }, [startDate, endDate]);

  const renderDate = useCallback((value) => {
    return value ? <span>{moment(value).format('DD-MMM-YYYY')}</span> : <span>-</span>;
  }, []);

  const renderDateTime = useCallback((value) => {
    return value ? <span>{moment(value).format('DD-MMM-YYYY HH:mm')}</span> : <span>-</span>;
  }, []);

  const calculateTAT = useCallback((value, row) => {
    if (!row.reportUploadTime || !row.reportCompletionTime) {
      return <Badge bg="secondary">N/A</Badge>;
    }

    const start = moment(row.reportUploadTime);
    const end = moment(row.reportCompletionTime);

    if (!start.isValid() || !end.isValid()) {
      return <Badge bg="secondary">N/A</Badge>;
    }

    const duration = moment.duration(end.diff(start));
    const minutes = duration.asMinutes();

    if (minutes < 0) {
      return <Badge bg="danger">Invalid time range</Badge>;
    }

    if (minutes < 60) {
      return <Badge bg="primary">{`${Math.round(minutes)} mins`}</Badge>;
    } else {
      const hours = Math.floor(minutes / 60);
      const remainingMins = Math.round(minutes % 60);
      const tat = remainingMins > 0 ? `${hours}h ${remainingMins}m` : `${hours}h`;
      return <Badge bg="primary">{tat}</Badge>;
    }
  }, []);

  const columns = [
    { accessor: 'caseDate', label: 'Case Date', render: renderDate },
    { accessor: 'patientID', label: 'Patient ID' },
    { accessor: 'panel', label: 'Panel' },
    {
      accessor: 'studyNameAndModality',
      label: 'Study & Modality',
      render: (value, row) => {
        const study = row.studies[0];
        return `${study.studyName} (${study.Modality})`;
      },
    },
    { accessor: 'images', label: 'Images' },
    { accessor: 'assignments', label: 'Assigned Doctor', render: (value) => value?.join(', ') || '-' },
    { accessor: 'completedBy', label: 'Completed By' },
    { accessor: 'centerName', label: 'Centre Name' },
    {
      accessor: 'reportUploadTime',
      label: 'Report Upload Time',
      render: renderDateTime,
    },
    {
      accessor: 'reportCompletionTime',
      label: 'Report Completion Time',
      render: renderDateTime,
    },
    {
      accessor: 'tat',
      label: 'TAT',
      render: calculateTAT,
    },
  ];

  return (
    <Container fluid className="px-0 text-nowrap">
      <div className="bg-white p-4 min-vh-100 shadow-sm">
        <h3 className="base-color mb-2">Turnaround Time</h3>
        <div className="position-absolute mt-2 pt-1">
          <DatePicker setStartDate={setStartDate} setEndDate={setEndDate} setIsDataFetched={setIsDataFetched} />
        </div>

        <CommonTable data={getFilteredData()} columns={columns} loading={false} />
      </div>
    </Container>
  );
};

export default TurnaroundTime;
